module.exports = __webpack_public_path__ + "static/img/mylogo.5b370da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mylogo.png
// module id = CUkX
// module chunks = 9